module.exports = __webpack_public_path__ + "img/02-6解决方案.aa0754a6.png";